import type3 from "./type3/index.js";

export { type3 };
export default { type3 };
